/* eslint-disable no-undef */
const packageJson = require('../package.json');

export const API_URL = process.env.REACT_APP_API_ROOT_URL;
export const CDN_URL = 'https://remarc-assets.bbcrewind.co.uk';

// These are in a webpack config in Discover
export const VERSION = packageJson.version;
export const ENVIRONMENT = process.env.NODE_ENV || 'development';
